module.exports = __webpack_public_path__ + "static/img/big-right.82073694.png";